<template>
    <i class="fad fa-comment" style="color:#000000; --fa-secondary-color: #ffffff; --fa-secondary-opacity: 1.0"></i>
</template>

<script>
    export default {
        name: 'HasCommentsIcon',
    }
</script>

<style scoped>

</style>
